import React from 'react';
import { connect } from 'react-redux';
import { NavLink } from 'react-router-dom';
import { EditIcon, CloseIcon } from './../../../themes/icons';
import { Loading } from './../../../components/includes/loading';
import { Section, Content, Main, Buttons, FormActions } from './../../../components/includes/container';
import { ToolbarPrimary } from './../../../components/includes/toolbar';
import { BreadcrumbItem } from './../../../components/includes/breadcrumb';
import { Table, Thead, Tbody, Row, Cell, Tresponsive, Ttolbar, Tpagination } from './../../../components/includes/ui/table';
import { Btn, Link, Label } from './../../../components/includes/ui';
import { Modal } from './../../../components/includes/modal';
import { FormatDate } from './../../../utilities/date';
import { isUndefined, isSorting, isStatus, parseQueryString } from './../../../utilities/utils';
import { AutogestionService } from './../../../services';
import Confirm from './../../shared/confirm';
import PageAutogestionFilter from './../filter';

import API from './../../../config/api';

const rows = [
  { id: 'name', sort: false, numeric: false, disablePadding: false, label: 'Nombre' },
  { id: 'status', sort: false, numeric: false, disablePadding: false, label: 'Estado' },
  { id: 'created_at', sort: false, numeric: false, disablePadding: false, label: 'Creado' },
  { id: 'updated_at', sort: false, numeric: false, disablePadding: false, label: 'Editado' },
  { id: 'actions', sort: false, numeric: true, disablePadding: false, label: 'Acciones', width:120, minWidth: 120 }
];

class Autogestion extends React.Component {

  constructor(props){
    super(props);
    this.state = {
      loading: false,
      page: 0,
      order: 'desc',
      orderBy: 'created_at',
      entities: null,
      formDeleteShow: false,
      formDeleteMessage: null,
      formFilterShow: false
    };
  }

  componentDidMount() {

    let page = this.props.match.params.page || 0;

    if (!isUndefined(page)) {

      if (!isNaN(page) && page >= 0) {

        this._Find(page);

      } else {

        this.props.history.push('/autogestion');

      }

    } else {

      this._Find(this.state.page);

    }

  }

  componentDidUpdate(next_props){
    if(next_props.match.params.page !== this.props.match.params.page){
      this._Find(this.props.match.params.page);
    }

    if(next_props.location.search !== this.props.location.search){
      this._Find(this.props.match.params.page || 0, parseQueryString(this.props.location.search));
    }
  }

  /*
  ** @Service
  ** @Description: FindAll
  */

  _Find = (page) => {

    AutogestionService.get(page, parseQueryString(this.props.location.search)).then((response) => {

      this.setState({ loading: true, page: !isUndefined(page) ? parseInt(page,10) : 0, entities: response });

    }).catch((error) => {

      this.props.AlertShow({ open: true, variant: 'error', message: Error.internal });

    });

  }

  /*
  ** @Service
  ** @Description: Delete
  */

  _Delete = (id) => {

    AutogestionService.remove(id).then((response) => {

      // @State
      this.setState({ formDeleteShow: false });

      // @Service find all by page
      this._Find(this.props.match.params.page);

      // @Dispatch alert success
      this.props.AlertShow({ open: true, variant: 'success', message: `Exito, el recurso fue eliminado.` });

    }).catch((error) => {

      // @Dispatch alert error
      this.props.AlertShow({ open: true, variant: 'error', message: Error.internal });

    });

  }

  /*
  ** @Event
  ** @Description: Delete user
  */

  handleDelete = (id, name) => {
    this.setState({
      id: id,
      formDeleteShow: true,
      formDeleteMessage: `¿Confirma la eliminación de ${ name }?`
    });
  }

  /*
  ** @Click
  ** @Description: Delete user
  */

  handleConfirmDeleteConfirm = () => {
    this._Delete(this.state.id);
  }

  /*
  ** @Click
  ** @Description: Cancel delete user
  */

  handleConfirmDeleteCancel = () => {
    this.setState({ formDeleteShow: false });
  }

  /*
  ** @Click
  ** @Description: Cancel filter
  */
  handleOpenFilterShow = () => {
    this.setState({ formFilterShow: true });
  };

  /*
  ** @Click
  ** @Description: Cancel filter
  */
  handleCancelFilterShow = () => {
    this.setState({ formFilterShow: false });
  };

  /*
  ** @Handle
  ** @Description: Change page
  */

  handleChangePage = (event, page) => {
    this.setState({ page });
    //this.props.history.push(`/autogestion/page/${ page }`);
    this.props.history.push({
      pathname: `/autogestion/page/${ page }`,
      search: this.props.location.search
    });
  };

  render() {

    const { loading, order, orderBy, entities, formFilterShow } = this.state;

    return (
      <Section>

        <ToolbarPrimary title="Autogestión"/>
        <BreadcrumbItem to='/autogestion'>Autogestión</BreadcrumbItem>

        <Content>
          <Main>

            <Confirm
               status={ this.state.formDeleteShow }
               message={ this.state.formDeleteMessage }
               cancel={ () => { this.handleConfirmDeleteCancel() } }
               confirm={ () => { this.handleConfirmDeleteConfirm() } }
            />

            <Modal
              status={formFilterShow}
              title="Filtrar"
              handleCancel={this.handleCancelFilterShow}
              maxWidth="sm"
            >
              <PageAutogestionFilter onSuccess={ this.handleCancelFilterShow }/>
            </Modal>

            <Ttolbar title="Autogestión">
              <Buttons>
                { this.props.location.search !== '' && (
                  <Btn
                    icon="remove"
                    size="medium"
                    color="danger"
                    title="Eliminar filtros"
                    component={ NavLink }
                    to="/autogestion"
                  />
                )}
                <Btn color="info" aria-label="add" icon="filter" onClick={this.handleOpenFilterShow}>
                  Filtrar
                </Btn>
                <Btn color="success" aria-label="add" icon="add" component={ NavLink } to="/autogestion/create">
                  Crear recurso
                </Btn>
              </Buttons>
            </Ttolbar>

            { loading ? (
              <React.Fragment>

                <Tresponsive enabledActions>
                  <Table>

                    <Thead rows={ rows } order={ order } orderBy={ orderBy } onRequestSort={ this.handleRequestSort }/>

                    <Tbody>

                      { entities.autogestion.length > 0 ? (

                        entities.autogestion.sort(isSorting(order, orderBy)).map(entity => {
                          return (
                            <Row key={ entity._id }>
                              <Cell>
                                <span>
                                  <Link to={ `${ API.endpoint.cdn }/p/berners/autogestion/${ entity.slug }` } isExrernal>
                                    { entity.name }
                                  </Link>
                                </span>
                              </Cell>
                              <Cell>
                                <Label variant={ entity.status ? "success" : "danger"}>
                                  { isStatus(entity.status) }
                                </Label>
                              </Cell>
                              <Cell>
                                <FormatDate value={ entity.created_at }/>
                              </Cell>
                              <Cell>
                                <FormatDate value={ entity.updated_at }/>
                              </Cell>
                              <Cell numeric>
                                { !entity.delete_disabled && (
                                  <Btn color="danger" size="xsmall" onClick={ () => { this.handleDelete(entity._id, `${ entity.name }`) } }>
                                    <CloseIcon fontSize="small"/>
                                  </Btn>
                                )}
                                <Btn color="primary" size="xsmall" component={ NavLink } to={ `/autogestion/update/${ entity._id }` }>
                                  <EditIcon fontSize="small"/>
                                </Btn>
                              </Cell>
                            </Row>
                          );
                        })

                      ) : (

                        <Row key="1">
                          <Cell colSpan={ rows.length }>No se encontraron resultados.</Cell>
                        </Row>

                      )}

                    </Tbody>
                  </Table>
                </Tresponsive>

                { entities.autogestion.length > 0 && (
                  <FormActions disablePadding>
                    <Tpagination count={ entities.total } page={ this.state.page } onChangePage={ this.handleChangePage } />
                  </FormActions>
                )}

              </React.Fragment>

            ) : (
              <Loading variant="primary"/>
            ) }

          </Main>
        </Content>
      </Section>
    )
  }
}

const mapStateToProps = (state) => {
  return {
    Alert: state.Alert
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    AlertShow: (data) => {
      dispatch({
        type: 'ALERT_SHOW',
        data: data
      });
    }
  }
}

export default connect(mapStateToProps, mapDispatchToProps)(Autogestion);
